var _path, _path2, _path3, _path4, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4798 41.0957H5.82762C5.02321 41.0957 4.37109 41.4265 4.37109 41.8346V55.1353C4.37109 55.5434 5.02321 55.8742 5.82762 55.8742H17.4798C18.2842 55.8742 18.9363 55.5434 18.9363 55.1353V41.8346C18.9363 41.4265 18.2842 41.0957 17.4798 41.0957Z",
    fill: "url(#paint0_linear_1429_5192)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3274 19.1367H27.6753C26.8708 19.1367 26.2188 19.6205 26.2188 20.2173V54.7948C26.2188 55.3915 26.8708 55.8753 27.6753 55.8753H39.3274C40.1319 55.8753 40.784 55.3915 40.784 54.7948V20.2173C40.784 19.6205 40.1319 19.1367 39.3274 19.1367Z",
    fill: "url(#paint1_linear_1429_5192)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1731 44.5771H49.521C48.7165 44.5771 48.0645 44.9986 48.0645 45.5185V54.9324C48.0645 55.4523 48.7165 55.8738 49.521 55.8738H61.1731C61.9776 55.8738 62.6297 55.4523 62.6297 54.9324V45.5185C62.6297 44.9986 61.9776 44.5771 61.1731 44.5771Z",
    fill: "url(#paint2_linear_1429_5192)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9601 60.0137H7.03986C6.23586 60.0137 0 62.3521 0 63.1561C0 63.9601 0.652522 64.6126 1.45652 64.6126H65.5435C66.3475 64.6126 67 63.9601 67 63.1561C67 62.3521 60.7641 60.0137 59.9601 60.0137Z",
    fill: "url(#paint3_linear_1429_5192)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_1429_5192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4798 24.1729H5.82762C5.02321 24.1729 4.37109 24.8825 4.37109 25.7579V54.2889C4.37109 55.1643 5.02321 55.8739 5.82762 55.8739H17.4798C18.2842 55.8739 18.9363 55.1643 18.9363 54.2889V25.7579C18.9363 24.8825 18.2842 24.1729 17.4798 24.1729Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4798 24.1729H5.82762C5.02321 24.1729 4.37109 24.8825 4.37109 25.7579V54.2889C4.37109 55.1643 5.02321 55.8739 5.82762 55.8739H17.4798C18.2842 55.8739 18.9363 55.1643 18.9363 54.2889V25.7579C18.9363 24.8825 18.2842 24.1729 17.4798 24.1729Z",
    fill: "url(#paint4_linear_1429_5192)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82762 24.7729H17.4798C17.9061 24.7729 18.3363 25.1651 18.3363 25.7579V54.2889C18.3363 54.8817 17.9061 55.2739 17.4798 55.2739H5.82762C5.40133 55.2739 4.97109 54.8817 4.97109 54.2889V25.7579C4.97109 25.1651 5.40133 24.7729 5.82762 24.7729Z",
    stroke: "url(#paint5_linear_1429_5192)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_1429_5192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3274 2.3877H27.6753C26.8708 2.3877 26.2188 3.09202 26.2188 3.96084V54.3016C26.2188 55.1704 26.8708 55.8747 27.6753 55.8747H39.3274C40.1319 55.8747 40.784 55.1704 40.784 54.3016V3.96084C40.784 3.09202 40.1319 2.3877 39.3274 2.3877Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3274 2.3877H27.6753C26.8708 2.3877 26.2188 3.09202 26.2188 3.96084V54.3016C26.2188 55.1704 26.8708 55.8747 27.6753 55.8747H39.3274C40.1319 55.8747 40.784 55.1704 40.784 54.3016V3.96084C40.784 3.09202 40.1319 2.3877 39.3274 2.3877Z",
    fill: "url(#paint6_linear_1429_5192)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6753 2.9877H39.3274C39.7578 2.9877 40.184 3.37903 40.184 3.96084V54.3016C40.184 54.8834 39.7578 55.2747 39.3274 55.2747H27.6753C27.2449 55.2747 26.8188 54.8834 26.8188 54.3016V3.96084C26.8188 3.37903 27.2449 2.9877 27.6753 2.9877Z",
    stroke: "url(#paint7_linear_1429_5192)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bi_1429_5192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.1731 36.8525H49.521C48.7165 36.8525 48.0645 37.5622 48.0645 38.4376V54.2881C48.0645 55.1636 48.7165 55.8732 49.521 55.8732H61.1731C61.9776 55.8732 62.6297 55.1636 62.6297 54.2881V38.4376C62.6297 37.5622 61.9776 36.8525 61.1731 36.8525Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1731 36.8525H49.521C48.7165 36.8525 48.0645 37.5622 48.0645 38.4376V54.2881C48.0645 55.1636 48.7165 55.8732 49.521 55.8732H61.1731C61.9776 55.8732 62.6297 55.1636 62.6297 54.2881V38.4376C62.6297 37.5622 61.9776 36.8525 61.1731 36.8525Z",
    fill: "url(#paint8_linear_1429_5192)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.521 37.4525H61.1731C61.5995 37.4525 62.0297 37.8448 62.0297 38.4376V54.2881C62.0297 54.881 61.5995 55.2732 61.1731 55.2732H49.521C49.0947 55.2732 48.6645 54.881 48.6645 54.2881V38.4376C48.6645 37.8448 49.0947 37.4525 49.521 37.4525Z",
    stroke: "url(#paint9_linear_1429_5192)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_1429_5192",
    x: -19.6289,
    y: 0.172852,
    width: 62.5654,
    height: 79.7012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5192"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5192",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5192"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_1429_5192",
    x: 2.21875,
    y: -21.6123,
    width: 62.5654,
    height: 101.487,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5192"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5192",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5192"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bi_1429_5192",
    x: 24.0645,
    y: 12.8525,
    width: 62.5654,
    height: 67.0205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5192"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5192",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5192"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1429_5192",
    x1: 4.97798,
    y1: 44.0514,
    x2: 20.8639,
    y2: 46.2259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1429_5192",
    x1: 26.8256,
    y1: 26.4844,
    x2: 42.9603,
    y2: 27.3729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1429_5192",
    x1: 48.6713,
    y1: 46.8365,
    x2: 64.3521,
    y2: 49.6445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1429_5192",
    x1: 2.79167,
    y1: 60.9335,
    x2: 17.4052,
    y2: 90.5027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1429_5192",
    x1: 4.97798,
    y1: 30.5131,
    x2: 21.0959,
    y2: 31.5416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8940FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1429_5192",
    x1: 4.82626,
    y1: 25.6138,
    x2: 18.9363,
    y2: 25.6138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1429_5192",
    x1: 26.8256,
    y1: 13.0851,
    x2: 42.9861,
    y2: 13.6963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8940FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1429_5192",
    x1: 26.6739,
    y1: 4.81892,
    x2: 40.784,
    y2: 4.81892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1429_5192",
    x1: 48.6713,
    y1: 40.6567,
    x2: 64.6739,
    y2: 42.3586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8940FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1429_5192",
    x1: 48.5196,
    y1: 37.7171,
    x2: 62.6297,
    y2: 37.7171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBar);
export default __webpack_public_path__ + "static/media/chart-bar.1748a05d5beb7aaccc6863a4acbc70e6.svg";
export { ForwardRef as ReactComponent };